export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5350.e7a52636.jpg";